import React, { useEffect } from "react";

const GoogleMap = (props: {
  id: number;
  latitude: number;
  longitude: number;
}) => {
  useEffect(() => {
    try {
      // @ts-ignore
      window.GMap.init();
    } catch (e) {
      console.warn("Fail to start Google Map");
    }
  }, []);
  return (
    <div className={"js-map-holder"}>
      <div
        className={"map js-map js-ajax-map"}
        style={{ paddingTop: "56%" }}
        data-lat={props.latitude}
        data-lng={props.longitude}
        data-zoom="11"
        data-pin={"/themes/zimple/assets/images/icon-pin-inactive.svg"}
        data-active-pin={"/themes/zimple/assets/images/icon-pin-active.svg"}
        data-locations={JSON.stringify([
          { id: props.id, lat: props.latitude, lng: props.longitude },
        ])}
      />
    </div>
  );
};

export default GoogleMap;
